import Vue from 'vue'
import App from './App'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import 'common/stylus/index.styl'
import LangCongig from 'common/lang/config'
import globalPlugin from './services/GlobalPlugin'
import store from './store'
import Cookie from 'js-cookie'
import method from 'common/method/method'
import webSocket from './services/webSocket.js'
import vueLoading from 'base/loading/index.js'
import VueWorker from 'vue-worker'
import router from './router' // 将router在第三方库样式之后引入打包, 避免自定义样式被覆盖
import VueI18n from 'vue-i18n'

Vue.use(globalPlugin)
Vue.use(VueI18n)
Vue.use(method)
Vue.use(vueLoading)
Vue.use(VueWorker)
const i18n = new VueI18n({
  // 默认语言
  locale: LangCongig.DEFAULT_LANG,
  messages: LangCongig.LOCALES
})

Vue.use(ViewUI, {
  // 解决vue与i18n兼容报错
  i18n: function (path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
})
Vue.locale = () => { }

Vue.prototype.$Cookie = Cookie
Vue.prototype.$webSocket = webSocket
// 存储订阅的车辆信息
Vue.prototype.$DevInfo = new Map()
// 存储车辆信息
Vue.prototype.$VehicleInfo = new Map()
// 存储报警
Vue.prototype.$alramsMap = new Map()
// 存储围栏信息
Vue.prototype.$fenceMap = new Map()
// 存储屏蔽报警信息
Vue.prototype.$ShieldingAlarmList = []

// 用户类型
// 部标
Vue.prototype.$isDepartmentStandard = false
// 物流锁
Vue.prototype.$isLogisticsLock = false
// 出租车
Vue.prototype.$isTaxi = false
// 海外版本
Vue.prototype.$isOversea = false
// 中俄, 仅用于中俄项目
Vue.prototype.$isRussia = false
// 吉林团标
Vue.prototype.$isJiLin = false
// 仅用于过检的功能, 其他情况应为false
Vue.prototype.$onlyCheck = false
// HK1980, 其他情况应为false
Vue.prototype.$HK1980 = false
// 丹东渔船, 其他情况应为false
Vue.prototype.$isDanDong = false
// GPSTracker, 其他情况应为false
Vue.prototype.$isGPSTracker = false
// TBOX设备, 其他情况应为false
Vue.prototype.$isTBOX = false
// 搅拌机, 其他情况应为false
Vue.prototype.$isBlender = false
// F3-808, 其他情况应为false
Vue.prototype.$isF3_808 = false
// 是否36路, 其他情况应为false
Vue.prototype.$is36channel = false
// 美国Bolide
Vue.prototype.$isUSBolide = false
// ADAS
Vue.prototype.$isAdasOpen = false
// DSN
Vue.prototype.$isDsmOpen = false

// 主动关闭websocket
Vue.prototype.$isActiveCloseWS = false

Vue.config.productionTip = false
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
export default vm



// WEBPACK FOOTER //
// ./src/main.js